// extracted by mini-css-extract-plugin
module.exports = {"Footer":"HomepageFooter-Footer-1w9c2q","Sponsor":"HomepageFooter-Sponsor-1zf2in"};